import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import * as ethers from 'ethers';
import { useTranslation } from 'react-i18next';
import { configJsonState } from "../../states/configJsonState";
import { useRecoilValue } from "recoil";

type Props = {

}
export const GotoWebSiteButton: React.FC<Props> = (props) => {
  const [buttonText,setButtonText] = React.useState(`特設サイトに進む`);
  const configStatus = useRecoilValue(configJsonState);
  const [t, i18n] = useTranslation();
  const GotoWebSiteButtonDivComponent = styled.div`
    margin-top: 0px;
  `;
  const GotoWebSiteButtonComponent = styled.button`
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    backdrop-filter: blur(50px);
    border-radius: 5px;
    background: linear-gradient(175.15deg, #F6F0F2 3.05%, #E89CEE 37.82%, #DAE4FF 68.31%, #B6CBFF 96.09%);
    font-weight: 700;
    box-sizing: border-box;
    width: 314px;
    height: 60px;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    margin-bottom: 5px;
    transition: all 0.5s;
    background-image: url('https://nfttopshot-template.onrender.com/template-images/btn-rainbow-square-bg.png');
    color: ghostwhite;
    font-size: 21px;

    &:hover {
        opacity: 0.8;
        background-color: rgba(255, 255, 255, .2);
      }
  `;
  React.useEffect(()=>{
    (async() => {

    })()
  },[]);
  return (
    <GotoWebSiteButtonDivComponent>
        <div id="marketplacemesbrowserwalletdiv">
            <GotoWebSiteButtonComponent 
              type="button" 
              onClick={()=>{
                  window.open(`${configStatus.web3layerUrl}`);
              }}
            >
            {t(buttonText)}
            </GotoWebSiteButtonComponent>
        </div>
    </GotoWebSiteButtonDivComponent>
  );
};